if (!customElements.get('article-floating-product-card')) {
  customElements.define(
    'article-floating-product-card',
    class ArticleFloatingProductCard extends HTMLElement {
      connectedCallback() {
        this.variantInput = this.querySelector('[name="id"]');
        this.submitButton = this.querySelector('[data-floating-submit]');
        this.variantButtons = Array.from(this.querySelectorAll('[data-variant-id]'));
        this.addLabelTemplate = this.dataset.addVariantLabel || '';
        this.onVariantClick = this.onVariantClick.bind(this);

        this.variantButtons.forEach((button) => button.addEventListener('click', this.onVariantClick));

        this.onCartUpdate = this.onCartUpdate.bind(this);
        if (typeof subscribe === 'function') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
        }
      }

      disconnectedCallback() {
        this.variantButtons.forEach((button) => button.removeEventListener('click', this.onVariantClick));
        this.cartUpdateUnsubscriber?.();
      }

      onVariantClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const button = event.currentTarget;
        if (button.disabled || !button.dataset.variantId) return;

        this.variantButtons.forEach((variantButton) => {
          const isSelected = variantButton === button;
          variantButton.classList.toggle('is-selected', isSelected);
          variantButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        if (this.variantInput) {
          this.variantInput.value = button.dataset.variantId;
          this.variantInput.disabled = false;
        }

        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-disabled');

          if (button.dataset.variantTitle) {
            const label = this.addLabelTemplate.replace('VARIANT', button.dataset.variantTitle);
            if (label) this.submitButton.setAttribute('aria-label', label);
          }
        }
      }

      onCartUpdate(event) {
        if (event.source !== 'product-form') return;

        const variantId = this.variantInput?.value;
        if (event.productVariantId && variantId && String(event.productVariantId) !== String(variantId)) return;

        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        cartDrawer.classList.remove('is-empty');

        try {
          if (event.cartData && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(event.cartData);
            return;
          }
        } catch (error) {
          console.error(error);
        }

        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }
    }
  );
}

if (!customElements.get('article-floating-product')) {
  customElements.define(
    'article-floating-product',
    class ArticleFloatingProduct extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-floating-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-floating-dots] .article-floating-product__dot'));
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.index = 0;

        if (this.slides.length < 2) return;

        this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
        this.show(this.index);
      }

      goTo(nextIndex) {
        const total = this.slides.length;
        this.index = ((nextIndex % total) + total) % total;
        this.show(this.index);
      }

      show(index) {
        this.slides.forEach((slide, i) => {
          if (i === index) {
            slide.removeAttribute('hidden');
          } else {
            slide.setAttribute('hidden', '');
          }
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      }
    }
  );
}
